import { z } from 'zod'

const envSchema = z.object({
  VITE_HERE_API_KEY: z.string().min(1, 'VITE_HERE_API_KEY is required'),
  VITE_API_BASE_URL: z
    .string()
    .min(1, 'VITE_API_BASE_URL is required')
    .default('https://api.mygroute.com'),
  VITE_SENTRY_DSN: z.string().min(1, 'VITE_SENTRY_DSN is required'),
  VITE_SENTRY_ENV: z
    .string()
    .min(1, 'VITE_SENTRY_ENV is required')
    .default('development'),
  VITE_SENTRY_RELEASE: z.string().optional(),
})

export const env = envSchema.parse(import.meta.env)
